import { useEffect } from "react";
import type { OrgStatus } from "@delta/shared";
import type { T } from "../../i18n";
import { ApiFailure } from "../../lib/api";

// Helpers shared by the platform portal's screens.

export const errText = (t: T, e: unknown) => {
  if (!(e instanceof ApiFailure)) return t("serverError");
  const k = `pfErr_${e.code}`;
  const s = t(k, { limit: e.limit ?? "" });
  if (s !== k) return s;
  if (e.code === "validation") return t("fixRequired");
  return e.status === 401 ? t("sessionEnded") : t("serverError");
};
export const FIELD: Record<string, string> = { required: "fieldRequired", too_short: "fieldTooShort", limit_range: "pfLimitRange", code_format: "pfCodeFormat", plan_code_taken: "pfErr_plan_code_taken", date_format: "dateFormat", before_start: "pfBeforeStart", not_found: "fieldRequired", no_contact: "fieldRequired",
  in_past: "pfInPast", not_later: "pfNotLater", unknown_feature: "fieldRequired", currency_format: "pfCurrencyFormat", price_format: "pfPriceFormat", trial_no_price: "pfTrialNoPrice", trial_days_range: "pfTrialDaysRange", too_long: "fieldTooLong", module_dependency: "fieldModuleDependency",
  mobile_format: "fieldMobileFormat", email_format: "fieldEmailFormat", phone_taken: "abPhoneTaken", email_taken: "abEmailTaken", delivery_unavailable: "abNoProvider", password_rule: "fieldPasswordRule", password_is_mobile: "fieldPasswordIsMobile",
  phone_format: "fieldPhoneFormat", social_url: "fieldSocialUrl", not_public: "pfWsNotPublicErr", unknown_package: "pfWsNotPublicErr" };
export const fieldErrs = (t: T, e: unknown) => (e instanceof ApiFailure ? Object.fromEntries(Object.entries(e.fields).map(([k, c]) => [k, t(FIELD[c] ?? "fieldRequired")])) : {});
export const when = (iso: string | null, lang: string) => (iso ? new Date(iso).toLocaleString(lang === "ar" ? "ar-SA-u-nu-latn" : "en-GB", { dateStyle: "medium", timeStyle: "short" }) : "--");
export const statusPill = (t: T, s: OrgStatus) => <span className={`pill ${s === "active" ? "good" : s === "pending" ? "warn" : s === "suspended" || s === "rejected" ? "bad" : ""}`} data-status={s}>{t(`pfStatus_${s}`)}</span>;

export function Title({ text }: { text: string }) {
  useEffect(() => { document.title = `${text} · Delta Platform`; }, [text]);
  return <h1>{text}</h1>;
}

